import { apiFetch } from "@/hooks/apiFetch"

export const fetchProducts = async (
  { page = 1, searchQuery = "", perPage = 30 },
  signal?: AbortSignal
) =>
  apiFetch(`product?page=${page}&per_page=${perPage}&search=${searchQuery}`, {
    signal,
  })
